import React from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Field, getFormValues } from 'redux-form'
import { Fade } from '@material-ui/core'
import { Icon, Button } from 'semantic-ui-react'

import Approvers from 'routes/ProcurementSystem/Shared/DocumentStep/Approvers'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard } from 'components'

import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import { Container } from './styled'

const RequestInfo = props => {
  const {
    isCreate = false,
    isEdit = false,
    isDetail = false,
    members,
    valueForm,
    goaWorkFlow
  } = props

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title="Request Information"
          accessoriesHeader={
            (isCreate||isEdit)&&
            <Approvers 
              approvers={goaWorkFlow.data} 
              status={valueForm?valueForm.status:0}
              trigger={
                <Button 
                  basic  
                  circular 
                  type='button' 
                  loading={goaWorkFlow.loading} 
                  content='View Approver' 
                  labelPosition='right'
                  icon='sort numeric down' />
              }
            />
          }
        >
          <Container>
            <div className="rowFields">
              <Field
                name="title"
                label="Title"
                type={type.text}
                component={FieldInput}
                editable={((isCreate || isEdit))}
                require={!isDetail}
                maxLength={200}
                maxLengthMessage="Title must be less than or equal to 200 characters"
                tooltip={isDetail}
              />
              <Field
                name="requesterUser"
                label="Requester"
                require={!isDetail}
                editable={isCreate || isEdit}
                component={FieldInput}
                allowAdditions={false}
                loading={members.loading}
                options={members.map((m,i) => ({
                  key:i,
                  value: lower(m.username),
                  text: `${m.firstnameEn} ${m.lastnameEn}`,
                }))}
                type={type.select}
              />
            </div>
            <div className="rowFields">
              <Field
                name='companyName'
                label='Company'
                type={type.text}
                component={FieldInput}
                editable={false}
              />
              <Field
                name="documentDate"
                label="Document Date"
                type={type.date}
                component={FieldInput}
                editable={isCreate || isEdit}
                dateFormat='dd MMM yyyy'
                require={!isDetail}
              />
            </div>
            <div className="rowFields">
              <Field
                name='projectId'
                label='Project Name'
                loading={props.projectLoading}
                options={props.projects.map((x,i)=>({key:i,value:x.id,text:x.projectName}))}
                type={type.select}
                component={FieldInput}
                editable={isCreate || isEdit}
                className={isCreate?'halfRow':''}
                require={!isDetail}
              />
              {!isCreate ? (
              <Field
                name="submittedDate"
                label="Submitted Date"
                type={type.date}
                editable={false}
                component={FieldInput}
                dateFormat='dd MMM yyyy HH:mm'
              />) : null}
            </div>
            {valueForm.projectId!=null&&valueForm.projectId>0&&props.specialApprovals[valueForm.projectId]&&(props.specialApprovals[valueForm.projectId].length>0)&&
            <div className="rowFields">
              <Field
                name='specialApprovalId'
                label='Special Approval'
                loading={props.specialApprovalLoading}
                options={props.specialApprovals[valueForm.projectId].map((x,i)=>({key:i,value:x.id,text:x.name}))}
                type={type.select}
                component={FieldInput}
                editable={isCreate || isEdit}
                className='halfRow'
              />
            </div>}
          </Container>
        </StdCard>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = state => {
  let valueForm = getFormValues('formPOUpdate')(state)||{}
  return {
    members: state.member.members,
    goaWorkFlow: state.poUpdate.goaWorkFlow,
    valueForm: valueForm,
    specialApprovalLoading:state.goa.specialApprovalLoading,
    projects: state.goa.projects[valueForm.companyCode||""]||[],
    projectLoading: state.goa.projectLoading,
    specialApprovals:state.goa.specialApprovals,
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(RequestInfo)
